module.exports = __webpack_public_path__ + "static/media/favicon.266911cf.ico";